import { MiddlewareAPI } from 'redux';
import { useOnScreen } from 'common/hooks/use-on-screen';
import { sendTrackingImpressionClick, sendTrackingImpressionView } from './tracking-api/tracking-api';
import { useStore } from 'react-redux';

type TrackingProps = {
  productRef: React.MutableRefObject<HTMLDivElement | null>;
  contentId: string | undefined;
};

const viewedContentIds: string[] = [];
const clickedContentIds: string[] = [];

export const clickTracking = (store: MiddlewareAPI, impressionContentId: string) => {
  if (clickedContentIds.includes(impressionContentId)) return;

  sendTrackingImpressionClick(store, impressionContentId);

  clickedContentIds.push(impressionContentId);
};

export const viewTracking = (store: MiddlewareAPI, impressionContentId: string) => {
  if (viewedContentIds.includes(impressionContentId)) return;

  sendTrackingImpressionView(store, impressionContentId);

  viewedContentIds.push(impressionContentId);
};

export const useTracking = ({ productRef, contentId }: TrackingProps) => {
  const store = useStore();

  const isOnScreen = useOnScreen(productRef, {
    threshold: 0.5,
  });

  const sendClickEvent = () => {
    if (!contentId) return;

    clickTracking(store, contentId);
  };

  if (isOnScreen && contentId) viewTracking(store, contentId);

  return {
    sendClickEvent,
  };
};
